<template>
    <div v-if="conts.active == 1" class="wobuListContainer" :class="{emptyBundle: !data.items.length && this.conts.itemsLoaded, height100: $root.app.fulled, listContainer100: inWindow, 
        hideIt: ((info.branch[0] != $root.app.fulledBundle && $root.app.fulled == true) || (!$root.app.currentFilteredView.includes(info.branch[0]) && $root.app.filterView) && !inWindow), 
        top23: $root.app.fulled, noTopBorder: listIndex == 0 || $root.app.fulled}"  ref="listContainer">     

        <drop v-if="!inWindow && !$root.app.fulled" class="listDrop" :class="{listDropDragOver: dragging}" @dragover="handleDragOver"  @dragend="dragEnd" @dragleave="dragging=false" @drop="doDrop">
             <div v-if="dragging" class="has-text-white pointerEventsOff">
                 &nbsp;&nbsp;<i class="fa fa-arrow-right"></i>&nbsp;
                 <i class="fas fa-band-aid"></i>
             </div>
        </drop>
        <div class="bundleContent" :class="{height100: inWindow}">
            <div>
              
                <drag :transfer-data="{
                    listIndex: listIndex, 
                    type: 'list', 
                    fromSub: false, 
                    draggedId: rootId, 
                    collabId: conts.collabId}" class=" has-text-dark listTitleBar" @dragstart="dragStart"  @dragend="dragEnd">
                    <div>
                        <div v-if="conts.collabId" class="is-size-7 collabLabelContainer" :class="{inSingleMode: $root.app.fulled}">
                                <div class="top-3 collabLabel handCursor posRelative" @click="openCollabMenu">
                                    <span v-show="!conts.isPublic" class="has-text-white" v-tooltip="'collab bundle'">©</span>

                                    <div v-show="conts.isPublic" class="has-text-white" v-tooltip="'public collab bundle'">
                                        <span style="position: relative; top: -13px; left: -1px" class="is-size-4">©</span>
                                        <span style="position: relative; top: 4px; right: 1px; font-size: 23px"><b>℗</b></span>
                                        <div style="width: 30px; height: 30px; border-bottom: 2px solid #ccc; position: absolute;  transform: rotate(-45deg); top: -5px; left: -6px">&nbsp;
                                    </div>
                                </div>
                                    
                                </div>
                                <div v-show="showGroup" class="groupDisplay ">
                                    <div class="handCursor  bundleMenuItem bottom10" @click="openHistory"><i class="fas fa-stream"></i> Activity</div>
                                    <div v-for="(item, i) in groupMembers" :key="i" :class="{'has-text-grey': item.active == '0', 'has-text-coolGreen': item.owner == item.id_customer}">{{item.fName}} {{item.lName}}</div>
                                    <div v-if="collabMine"><button class="button xs is-coolGreen is-small top5" @click="addMembers(false)">Manage</button></div>
                                </div>
                            </div>
                        <div class="is-inline-block bundleHeader">
                            <div v-if="!$root.app.bundlesOpen && !$root.app.fulled" class="is-inline-block openBundleButton handCursor top3"><i :class="{'fa fa-angle-down' : openThisB, 'fa fa-angle-right': !openThisB}" @click="doBundleState"></i></div>
                          
                            
                          
                            <div class="is-inline-block has-text-coolGreen handCursor bundleHeaderLogo fourDots" @click="openBundleTree" >&nbsp;::</div>   <!-- :class="{red: hasDirtyChildren}" -->
                           
                            <div v-if="showBundleTree" class="bundleSubTree" @click="stopProp">
                                <!-- <div v-if="hasDirtyChildren" class="is-size-7 has-background-dark pad5"><button class="button is-small is-black redBorder">Manage Share Updates</button></div> -->
                                <span class="delete bundleSubTreeX" @click="showBundleTree = false"></span>
                                <div class="top5">
                                    <tree2 v-for="(item, index) in  $root.app.treeNoInbox[listIndex].children" 
                                        :key="index" 
                                        :listName="item.listName" 
                                        :children="item.children" 
                                        :depth="0" 
                                        :id="item.id" 
                                        :aliasTgtId="item.aliasTgtId"
                                        :rootBundleId="conts.id"
                                        :isDirty="item.dirt"
                                        :beenShared="item.beenShared"
                                        :path="[]">
                                    </tree2>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
    <!-- Breadcrumbs -->
                           <!--  <i v-if="hasDirtyChildren" class="fas fa-cloud-upload-alt red rootHasDirty is-size-7"></i> -->
                           <!--  <div>{{info.p}}</div> -->
                           
                            <div v-if="$root.app.movingAdding == conts.id"  class="is-loading2 is-inline"></div>
                           <div ref="breadCrumbsDiv" class="breadCrumbsDiv" :class="{bcInboxOpen : $parent.inbox, bcInboxClosed: !$parent.inbox && !data.collabId, bcInboxClosedCollab: !$parent.inbox && (data.collabId || data.isPublic)}">
                                
                            
                            
                                <drop ref="me"  class="is-inline noDrag" v-for="(name, i) in this.breadCrumbs" :key="i" @dragenter="crumbDragEnter(i, ...arguments)" @dragleave="crumbDragLeave(i, ...arguments)" @drop="subBundleDrop(name.id, i, name.aliasTgtId, ...arguments)">
                                    <div class="is-inline thickerText" ref="crumb">
                                        <span class="subBack" ref="bCrumb" @click="subBack(name.id, i)" :class="{'breadCrumbsRoot' : i==0, 'has-text-azGrey': i > 0, 'currentBreadCrumb': i==breadCrumbs.length-1, 'rootBreadCrumbNotCurrent': i==0  && breadCrumbs.length > 1}">{{name.listName}}</span> 
                                        <span v-if="i < breadCrumbs.length -1" class="has-text-grey-light"> <span class="breadCrumbSeparator">&gt;</span> </span>  
                                    </div>
                                </drop>

                                
                           </div>
                            
                          
                            <div v-show="conts.isPublic && !conts.collabId" class="pubLabelContainer is-size-7" :class="{inSingleMode: $root.app.fulled}" v-tooltip="'public bundle'" >
                                <div class="collabLabel">
                                    <div class="has-text-white" style="position: relative; top: -4px; font-size: 32px"><b>℗</b></div>
                                </div>
                            </div>
                           

                         
                           
                            
                           <!--  <i v-show="!inWindow && !$root.app.bundlesOpen" class="is-hidden-touch fa fa-window-maximize is-size-6 handCursor is-pulled-right" @click="$parent.openWindow(conts.id, listIndex, breadCrumbs[0].id)"></i>&nbsp; -->
                           
                            <div v-show="showImportedInfo" class="importedInfo is-size-7">
                                <div v-show="sharedBy == ''" class="holder top25"></div>
                                <div v-show="sharedBy != ''">
                                    Shared by: {{sharedBy}} <br>
                                    On: {{az.dateConvert(sharedOn)}}
                                    <button class="handCursor is-coolGreen is-small is-pulled-right top10" @click="navToSB">VIEW</button>
                                </div>
                            </div>

                            <!-- <i v-show="data.imported && !data.importAcl" class="fas fa-cloud-download-alt has-text-coolGreen is-pulled-right right-10 is-size-7 handCursor top-5" @click="doImportedInfo"></i>
                            <i v-show="data.beenShared && !data.exportAcl" class="fas fa-cloud-upload-alt is-pulled-right right3 is-size-7  handCursor top-5" :class="{red: data.dirt > 0, 'has-text-coolGreen': !data.dirt}" @click="doOfferUpdatePush"></i>
                            <i v-show="data.importAcl || data.exportAcl" class="fas fa-users is-pulled-right right3 is-size-7  handCursor top-5" :class="{red: data.dirt > 0, 'has-text-coolGreen': !data.dirt}" @click="doOfferUpdatePush"></i> -->
                        </div>
                        <div class="bundleNewControls" :class="{bundleNewControlsSingle: $root.app.fulled == true}"> 
                          
                            <!-- <img src="@/assets/img/pencil.png" width="20" class="handCursor" @click="editBundle"  v-tooltip="'edit bundle'" /> -->
                            <!-- <i  class="bundleWrench handCursor fas fa-wrench has-text-white is-size-5" @click="editBundle"  v-tooltip="'edit bundle'" ></i> -->
                            &nbsp;
                            <div class="is-inline-block has-text-light handCursor" @click.prevent="showMenu" >
                                <div><b>&vellip;</b></div>
                            </div>
                            <div class="bundleControlsMenu" v-show="showControlsMenu" @click="stopProp">
                                <input class="input searchTextInput left-5" type="text" v-model="terms"  @keyup.enter="localSearch"/>
                                <button class="button is-coolGreen is-small left-10 has-text-grey" style="z-index: 1" @click="localSearch"><i class="fa fa-search"></i></button>

                                <!-- <div class="bottom10 left-2 handCursor bundleMenuItem" @click="localSearch"><i class="fa fa-search is-size-6 handCursor sortControlButt" ></i>Search</div> -->
                                <div class="bottom10 handCursor bundleMenuItem top20" @click="editBundle"><i class="fa fa-wrench is-size-6 handCursor sortControlButt"></i>Edit Bundle</div>
                                <div class="bottom10 handCursor bundleMenuItem " @click="shareIt"><i class="fa fa-share is-size-6 handCursor sortControlButt"></i>Share Bundle</div>
                                <div class="bottom10 handCursor bundleMenuItem" @click="toggleMultiple"> <i class="fa fa-check is-size-6 handCursor sortControlButt" ></i>Multi-miimu Select</div>
                                
                                <!-- <div class="bottom10 handCursor bundleMenuItem" @click="toggleFulled"><i v-show="!inWindow" class="fa fa-window-maximize is-size-6 handCursor sortControlButt" ></i>Focus Bundle</div> -->
                                <div class="bundleMenuItem">---</div>
                                <div class="bottom10 left-2 handCursor bundleMenuItem" @click="makePublic"><i class="fa fa-users is-size-6 handCursor sortControlButt" ></i>Make {{conts.isPublic ? 'Private' : 'Public'}}</div>
                                <div v-if="data.isRoot && !data.collabId" class="bottom10 left-2 handCursor bundleMenuItem" @click="makeCollab"><i class="fa fa-link is-size-6 handCursor sortControlButt" ></i>Make Collab</div>
                                <div>
                                    <div class="is-size-7 has-text-coolGreen">Filter miimus:</div>
                                    <div id="bundleGroupsDropSelected" v-if="!filterTypeDrop" class="is-inline-block left-2 top3" @click="(e) => {e.stopPropagation(); filterTypeDrop = true}">
                                        <span class="bundleGroupDropItemSelected has-text-white">{{currFilterTypeName}}<div class="is-inline-block left2 has-text-coolGreen"><i class="fa fa-sort-down"></i></div></span>
                                    </div>
                                    <div v-if="filterTypeDrop" class="is-inline-block" id="filterTypeDrop">
                                        <div class="bundleMenuItem" v-for="(item, i) in $root.app.typeFilters" :key="i" :value="item.id" @click="filterTypeChanged(item.id, item.name)">{{item.name}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </drag>
            </div>
            <!-- <div v-show="$root.app.showContext" class="bundleContext">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce ut ligula libero. Phasellus posuere diam nec dui suscipit congue. Donec eget sapien at lacus malesuada rhoncus. Aliquam scelerisque magna sapien, et imperdiet sem dignissim id. Curabitur dictum erat ut sapien cursus, non sollicitudin nunc mattis. Praesent vitae diam a velit auctor auctor. Quisque fermentum purus justo, ac lobortis ipsum finibus id. Maecenas eu mauris tellus.</div> -->
           
            <div v-show="$root.app.showContext" class="width100p">
               
               
                <div ref="bNotesPubl"  class="bundleContext top12" >
                    <i style="font-size: .85rem" class="fas fa-pen has-text-coolGreen is-pulled-right right20 top13 handCursor" @click="openEditContext"></i>
                    <div v-html="conts.pubNote" v-linkified class="bundleContextNote"></div>
                    <div  v-show="!data.pubNote" class="notesLabelPlaceholder handCursor" :class="{notesLabelPlaceholderInSingleView: $root.app.fulled}" @click="openEditContext">notes</div>
                </div>
               
            </div>
           
           <transition name="slide" type="out-in">
               
                <div class="listBGcolor"  :class="{height100: inWindow, scrollVert : inWindow} ">
    <!-- subBundles -->
                
                    <div ref="subBundleList" class="subBundleList" @scroll="doOnScroll" style="padding-bottom: 2px" :class="{sortTrayOpen: sortTrayOpen}">
                        
                       <!-- <div class="anglesBt has-background-grey" v-show="breadCrumbs.length > 1" @click="upLevel"><i class="fas fa-angle-double-left has-text-white"></i></div> -->

                       <!-- <drop draggable v-for="(subBundle, theInd) in conts.children" :key="theInd" class="is-inline subLabelContainer" ref="subBundle" @dragenter="subBundleDragEnter(theInd)" @dragleave="subBundleDragLeave(theInd)" @drop="subBundleDrop(subBundle.id, theInd, ...arguments)">
                            
                            <div class="is-inline" @click="loadSub(subBundle, theInd)">
                                <div 
                                    class="subBundleLabel"   
                                    ref="subLabel">
                                        <div class="pointerEventsOff">
                                            <b  class="has-text-coolGreen pointerEventsOff">:: </b>
                                            <span class="pointerEventsOff">{{subBundle.listName}}</span>
                                        </div>
                                </div>
                               
                                <div v-if="subBundle.children.length > 0" class="is-inline subLabelDownArrow" @click="openSubDropdown(theInd, ...arguments)">
                                    <i  class="fa fa-sort-down"></i>
                                </div>
                                
                                <div class="subBundleDropDown hideIt" ref="subDropdowns">
                                    <div v-for="(child, i) in subBundle.children" :key="i" @click="loadSubFromDropdown(child, theInd, {listName: subBundle.listName, id: subBundle.id})"><span class="has-text-coolGreen"><b>::</b></span>{{child.listName}}</div>
                                </div>
                              
                            </div>
                       </drop> -->
                       <div class="newSubBt" @click="newSubBundle"><b>+</b></div>
                      <!--  <div class="unsortedBt has-text-centered"><b><span style="font-size: 18px">::</span> UNSORTED</b></div> -->
                       <sub-bundle ref="subBundle" class="is-inline handCursor darkHover" v-for="(subBundle, theInd) in conts.children" :key="theInd" :subBundle="subBundle" :theInd="theInd" :bundleId="data.id" :aliasTgtId="data.aliasTgtId"></sub-bundle>
                       <sub-bundle-drop ref="subBundle" class="is-inline left-12" :subBundle="{}" :bundleId="data.id" :aliasTgtId="data.aliasTgtId"></sub-bundle-drop> 
                       
                    </div>
                    

                   <!--  <div v-if="!inWindow" class="sortControls has-text-white posRelative">
                         <i class="fa fa-check is-size-6 handCursor sortControlButt" @click="toggleMultiple" v-tooltip="'Multiple Select'"></i>
                        <i class="fa fa-sticky-note is-size-6 handCursor sortControlButt" @click="openNotes" v-tooltip="'notes'"></i>
                        <i v-show="!inWindow" class="fa fa-window-maximize is-size-6 handCursor sortControlButt" @click="toggleFulled"  v-tooltip="'maximize'"></i>  
                      
                      
                        <span class="is-size-6 handCursor sortControlButt" @click="editBundle"  v-tooltip="'edit bundle'"><i class="fa fa-pen"></i></span>
                        <i class="fa fa-share is-size-6 handCursor sortControlButt" @click="shareIt"  v-tooltip="'share'"></i>
                         <i class="fa fa-users is-size-6 handCursor sortControlButt" @click="makePublic"  v-tooltip="'public'"></i>
                         <div class="is-inline-block vTop top2 has-text-centered" @click="toggleSortOpen">
                                <div class="cardVEllipsis2"><b>&vellip;</b></div>
                         </div>
                    </div> -->
                    
                    <div v-show="notesOpen" class="bundleNotes left8 vTop top-15 ">
                           <table width="100%">
                               <tr>
                                <!--  <td class="notesLabelTd" width="10">
                                        <div class="has-text-centered is-inline-block notesLabel">
                                            n<br>o<br>t<br>e<br>
                                        </div>
                                 </td> -->
                              
                                   <td>
                                        <div class="is-inline-block left15 width100p vTop posRelative ">
                                            <div class="top10 posRelative" >
                                                <div @click="showPrivate = !showPrivate" class="handCursor is-inline"><i class="fa fa-caret-right has-text-coolGreen" v-show="!showPrivate"></i><i class="fa fa-caret-down has-text-coolGreen" v-show="showPrivate"></i>&nbsp;<span class="is-size-7 has-text-grey" style="position: relative; top: -2px"><b>Private Note:</b> </span></div>
                                                <div v-show="showPrivate">
                                                    <div  ref="bNotesPriv" @focus="pvPlaceholderFocus" @blur="updNotes('nothing')"  class="top3 bundleNotesNote is-size-6 has-text-light" contenteditable="true" v-html="conts.privNote" v-linkified></div>
                                                    <div v-show="pvPlaceholder" class="notesLabelPlaceholder pointerEventsOff pvPlaceHolder">type private notes here</div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                   </td>
                               </tr>
                           </table>
                      
                    </div>
    <!-- bundle -->

  
                    <div v-show="$root.app.bundlesOpen || openThisB || ($root.app.fulled && $root.app.fulledBundle == conts.id)" class="posRelative">

                        
                 
                        <div class="wobuList" :class="{height100: inWindow, whiteSpaceNormal: $root.app.fulled && !$parent.inbox, fulledVertScroll: $root.app.fulled, alignCardsCenter: $root.app.fulled, wobuInboxOpen: $root.app.$refs.routerView.inbox, wobuInboxClosed: !$root.app.$refs.routerView.inbox}" ref="items">
                            <div class="bundleHoverLeft" v-show="conts.items.length && !$root.app.fulled && !$root.app.inApp" @mousedown="lMousePress" @mouseup="mouseRelease" :class="{scrollHoverCorrect: !scrollerVisible}"></div>
                            
                           <div class="bottom10">
                            <div class="is-inline"> <button v-show="inMultiSelect" class="button is-coolGreen is-small moveTagButt top10 left15" @click="openMulti">Move/Tag</button></div>
                                <button v-show="inMultiSelect" class="button is-small is-dark top10 left10 " @click="selectAll">ALL</button>
                                <button v-show="inMultiSelect" class="button is-small is-dark top10 left5 " @click="unSelectAll">NONE</button>
                                <div v-if="inMultiSelect" @click="toggleMultiple" class="delete largeDelete top13 left10"></div>
                               
                           </div>
                            
                            
                            <!-- <div v-if="!inWindow && !conts.items.length" class="linksLabel is-inline-block has-text-grey-light is-size-6"><b>[ add miimus ]</b> </div> -->
                            <span v-if="!inWindow">&nbsp;</span>

                           <!--  <div  class="google-ad scaled" :id="`banner-ad-${conts.id}`"></div> -->
                            <ad v-if="conts.items.length && $root.app.showAds && !forceShowWatermark" class="is-inline"></ad>
                           

                            <div v-show="!forceShowWatermark" class="wobuCardContainer" v-for="(item, index) in conts.items" :key=index>
                                <!--  <url-card  v-bind="item" :theCardsIndex="item.cardsIndex" :currImg="item.img"  v-bind:itemIndex="index" ref="cardRef"></url-card> --> <!-- v-bind:listIndex="listIndex" -->

                                <component :is="item.isAd ? 'ad' : 'url-card'"  v-bind="item" :theCardsIndex="item.cardsIndex" :currImg="item.img"  v-bind:itemIndex="index" ref="cardRef"></component>
                            </div> 
                            
                            <div v-show="(!conts.items.length && $root.app.showImages) || forceShowWatermark" class="bundleWatermark" :class="{watermarkWithNotes: $root.app.showContext && !conts.items.length && conts.itemsLoaded}">{{conts.listName}}</div>
                            <trans-drop-zone :id="'transDrop' + listIndex" ref="endTransDropZone" v-bind:itemIndex="conts.items.length" :style="[!$root.app.showImages ? {height: '63px'} : {}]"></trans-drop-zone> <!-- v-bind:listIndex="listIndex"  -->
                           <div class="bundleHoverRight" v-show="conts.items.length && !$root.app.fulled && !$root.app.inApp" @mousedown="rMousePress" @mouseup="mouseRelease" :class="{scrollHoverCorrect: !scrollerVisible}"></div>
                        </div>
                        
                        
               


                    </div>
                </div>  

                  
            </transition>
        </div>
         <div v-if="this.listIndex == az.page().currOpenWindow" class="bundleInWindow is-size-5 has-background-dark has-text-white">
            &nbsp;<span class="has-text-grey"><b>::</b></span> <span class="has-text-white"><b> {{rootName}} </b></span> <i class="fa fa-window-maximize is-size-6 handCursor" @click="$parent.closeWindow(conts.id, listIndex)"></i>&nbsp;
            <div class="is-size-7 has-text-white "><span style="position: relative; top: 3px">&nbsp;&nbsp;&nbsp;Currently Displayed in floating Window</span></div>
         </div>   
    </div>
</template>

<script>
import UrlCard from './UrlCard.vue'
import Tree2 from './Tree2.vue'
import TransDropZone from './TransDropZone.vue'
import ModalNewSub from '../components/ModalNewSub'
import Ad from '../components/Ad'
import ModalEditContext from '../components/ModalEditContext'
import SubBundle from '../components/SubBundle'
import SubBundleDrop from '../components/SubBundleDrop'
import bFactory from '../shared/bundleFactory.js'
import { AZEventBus } from './AZEventBus'
import { Drag, Drop } from 'vue-drag-drop'
import { timeStamp } from 'console'
import { throws } from 'assert'

function isOverflowY(element) {
  return element.scrollHeight != Math.max(element.offsetHeight, element.clientHeight)
}





export default {
    name: 'bundle',
    components: {UrlCard, TransDropZone, Drop, Tree2, SubBundle, SubBundleDrop, ModalEditContext, Ad},
    props: {
        info: Object,
        listIndex: Number,
        inWindow: {
            type: Boolean,
            default: false
        }
    },
    data: function(){
        return {
            dragging: false,
            breadCrumbs: [],
            data: {items: []},
            sortDirection: true,
            showBundleTree: false,
            rootName: '',
            az: az,
            bc: [],
            branch: [],
            showImportedInfo: false,
            sharedBy: '',
            sharedOn: '',
            sbId: '',
            notesOpen: false,
            showPrivate: false,
            //pbPlaceholder: true,
            pvPlaceholder: true,
            hasDirtyChildren: false,
            hideIt: false, 
            rootId: null,
            showGroup: false,
            collabMine: false,
            rootIsCurrent: true,
            sortTrayOpen: false,
            openThisB: false,
            inMultiSelect: false,
            multiSelections: [],
            showControlsMenu: false,
            ad: {},
            showSearch: false,
            crumbsOverflow: false,
            forceShowWatermark: false,
            adFreq: 10,
            ii: null,
            ii2: null,
            terms: '',
            filterTypeDrop: false,
            filterByType: false,
            offset: 0,
            observer: null



        }
    },
    mounted: function(){

       
        var self = this

        var freq = az.getRandomInt(10)
        if(freq < 5) freq += 5
        this.adFreq = freq

       /*  if(this.importedBreadCrumbs){
            this.breadCrumbs = this.importedBreadCrumbs
        } else {
            this.breadCrumbs.push({listName: this.info.listName, id: this.info.id})
        } */
        if(!this.info){
            return
        }

        this.data = this.info 
        this.data.items.sort(function(a,b){ return a.p - b.p})   

        

       

         //test to add random adds in items -- causes issues with drag and drop

       /*  this.data.items = this.data.items.filter(e => {
            return !e.isAd
        })*/

  
        ///////

        self.observer = new IntersectionObserver(function(entries) {
            // isIntersecting is true when element and viewport are overlapping
            // isIntersecting is false when element and viewport don't overlap
            if(entries[0].isIntersecting === true){
               
                self.observer.disconnect()
                self.loadItems()
            }
               
            }, { threshold: [0] 
            
        });

        if( this.data.items.length > 19 && !this.data.fullyLoaded){ // && this.data.itemsLoaded == false

            setTimeout(function(){ 
                if(self.$refs.cardRef && self.$refs.cardRef[19])
                    self.observer.observe(self.$refs.cardRef[19].$el);
            }, 10)

        }
       
    
        let bb = null

        bb = this.$root.app.bundles.find(e => {
            return e.id == this.data.branch[0]
        })

        if(bb != null){
            if(bb.hasDirtyBundles){
                this.hasDirtyChildren = true
            }
        }

        if(this.data.hasDirtyBundles){
            this.hasDirtyChildren = true
        } 
        
        

        AZEventBus.$on('bundleDeleted', this.bundleDeletedHandler)

        AZEventBus.$on('removeBundleFromCardsParents', this.removeBundleFromCardsParentsHandler)

        AZEventBus.$on('closeAllMenus', this.closeAllMenusHandler)

        AZEventBus.$on('subBundleTreeItemClicked', this.subBundleTreeItemClickedHandler)


    

        

/*         if(this.conts.pubNote == '') this.pbPlaceholder = true 
        else this.pbPlaceholder = false */
        
        if(this.conts.privNote == '') this.pvPlaceholder = true 
        else this.pvPlaceholder = false 



   /*      googletag.cmd.push(() => {
            // Define an ad slot for div with id "banner-ad".
            googletag
                    .defineSlot("/6355419/Travel/Europe/France/Paris", [300, 250], "banner-ad-" + this.conts.id)
                    .addService(googletag.pubads());

            // Enable the PubAdsService.
            googletag.enableServices();
        });

        setTimeout(function(){
            googletag.cmd.push(() => {
                    // Request and render an ad for the "banner-ad" slot.
                    window.googletag.display("banner-ad-" + self.conts.id);
            });

        }, 10) */
       
                        

    },

    beforeDestroy: function(){
     

        this.observer.disconnect()

        AZEventBus.$off('bundleDeleted', this.bundleDeletedHandler)

        AZEventBus.$off('removeBundleFromCardsParents', this.removeBundleFromCardsParentsHandler)

        AZEventBus.$off('closeAllMenus', this.closeAllMenusHandler)

        AZEventBus.$off('subBundleTreeItemClicked', this.subBundleTreeItemClickedHandler)
    },




    methods:{
        subBundleTreeItemClickedHandler: function(msg){
            if(this.conts.id == msg.rootBundleId){
                this.data = msg.b
                this.showBundleTree = false
            }
        },

        bundleDeletedHandler: function(msg){
            if(msg.id == this.conts.id && !this.conts.isRoot){
               this.upLevel()
            }
        },

        removeBundleFromCardsParentsHandler: function(msg){
            if(msg.id == this.conts.id){
               this.removeBundleFromCardsParents()
           }
        },

        closeAllMenusHandler: function(msg){
            this.showBundleTree = false
            this.showImportedInfo = false
            this.showGroup = false
            this.showControlsMenu = false

            this.filterTypeDrop = false

            this.sharedBy = ''
            this.sharedOn = ''
            this.sbId = ''

            for(var i in this.$refs.subDropdowns){
                if(this.$refs.subDropdowns[i].classList)
                    this.$refs.subDropdowns[i].classList.add('hideIt')
            }
        },
    

        loadItems: function(callBack, selections){

            
            if(this.data.offset){
                this.offset = this.data.offset
            } else {
                this.data.offset = 0
            }

            var self = this;

            function w(d){

           
               self.$root.app.movingAdding = false
               var cards = d.response.cards

               az.addRemSpinner(false, 'id', 'transDrop' + self.listIndex)


               for(var i = 0; i < cards.length; i++){
                   
                  
                    var already = self.$root.app.cards.findIndex(e => {
                        return e.id == cards[i].id
                    })

                   /*  if (already != -1)
                        continue */

                    var ind;
                    var parents = JSON.parse(cards[i].parents) || []
                    cards[i].parents = JSON.parse(cards[i].parents)
                    cards[i].tags = JSON.parse(cards[i].tags) || []

                    if(self.$root.app.userAttrs.sub != cards[i].id_cog){
                      cards[i].myCard = false
                    } else {
                      cards[i].myCard = true
                    }

                   

                    //*push or splice
                    if(already > -1){
                        self.$root.app.cards.splice(already, 1, cards[i])
                        cards[i].cardsIndexForInject = already
                    } else {
                        self.$root.app.cards.push(cards[i])  
                        cards[i].cardsIndexForInject = self.$root.app.cards.length - 1
                    }

                    var arrOfParentIds = []
                    for(var x = 0; x < parents.length; x++){

                        ind = self.$root.app.bundles.findIndex(e => {
                            if(e.aliasTgtId)
                                return e.aliasTgtId == parents[x].id 
                            else
                                return e.id == parents[x].id
                        })



                        //*push or splice
                        if(ind != -1){
                            arrOfParentIds.push(parents[x].id)
                            /* if(!already){
                                self.$root.app.bundles[ind].items.push({id: cards[i].id, p: parents[x].p, cardsIndex: self.$root.app.cards.length - 1, entryId: parents[x].entryId, id_cog: cards[i].id_cog})
                            } else { */
                                //get index of item
                                var itemIndex = self.$root.app.bundles[ind].items.findIndex(ii => {
                                    return ii.id == cards[i].id;
                                })
                                
                                
                                if(itemIndex > -1){
                                    self.$root.app.bundles[ind].items.splice(itemIndex, 1, {id: cards[i].id, p: parents[x].p, cardsIndex: already, entryId: parents[x].entryId, id_cog: cards[i].id_cog})
                                } else {
                                    self.$root.app.bundles[ind].items.push({id: cards[i].id, p: parents[x].p, cardsIndex: cards[i].cardsIndexForInject, entryId: parents[x].entryId, id_cog: cards[i].id_cog})
                                }
                                
                            //}  
                        }
                        
                    }

                  


                    for(var bdel = 0; bdel < self.$root.app.bundles.length; bdel++){
                        var b = self.$root.app.bundles[bdel]
                        

                        for(var ddel = 0; ddel < b.items.length; ddel++){
                            var idd = b.items[ddel].id
                           
                            if(!arrOfParentIds.includes(b.id) && idd == cards[i].id){
                                b.items.splice(ddel, 1)
                                break
                            }
                        }
                    }

                    self.conts.items.sort(function(a,b){ return a.p - b.p});

                    //ratings

                    d.response.ratings.forEach(e => {
                        self.$root.app.ratings.push(e)
                    })

                    d.response.ratingsAvg.forEach(e => {
                        self.$root.app.ratingsAvg.push(e)
                    })

                    let cd = self.$root.app.cards[cards[i].cardsIndexForInject]; 

                  

                    let myRatings = []
                    for(var l=0; l < d.response.ratings.length; l++){
                      if(d.response.ratings[l].id_CARDS == cd.id){
                        myRatings.push({collabId: d.response.ratings[l].id_COLLAB, rating:  d.response.ratings[l].rating})
                      }
                    }

                    

                    let avgRatings = []
                    for(l=0; l < d.response.ratingsAvg.length; l++){
                      if(d.response.ratingsAvg[l].id_CARDS == cd.id){
                        avgRatings.push({collabId: d.response.ratingsAvg[l].id_COLLAB, rating:  d.response.ratingsAvg[l].rating})
                      }
                    }

                   

                    let memAvg = []
                    for(l=0; l < d.response.memberAvg.length; l++){
                      if(d.response.memberAvg[l].id_CARDS == cd.id){
                        memAvg.push({collabId: d.response.memberAvg[l].id_COLLAB, rating:  d.response.memberAvg[l].rating})
                      }
                    }


                   

                    cd.myRatings = myRatings;
                    cd.avgMemRatings = memAvg;
                    cd.avgRatings = avgRatings;

                    

                }  
                
                let toCh = self.$root.app.bundles.find(e => {
                    return e.id == self.conts.id
                })

                toCh.itemsLoaded = true
                //toCh.fullyLoaded = true
                toCh.forceLoadFromInject = false

                let arr = d.response.tagUniverse
                let tu = {}
                arr.forEach(e => {
                    tu[e.tag] = e.tag
                })
                arr.forEach(e => {
                    self.$root.app.tagUniverse[e] = e
                })

                if(callBack){
                        callBack(selections)
                } else {
                    setTimeout(function(){ 
                        
                        if(self.$refs.cardRef && self.$refs.cardRef[19 + self.offset]){
                            self.observer.observe(self.$refs.cardRef[19 + self.offset].$el);
                            self.offset += 20
                            self.data.offset += 20
                        }
                    }, 10)
                }

            }

            function n(){
                az.addRemSpinner(false, 'id', 'transDrop'  + self.listIndex)
                self.$root.app.movingAdding = false
            }
            
            let al = this.data.aliasTgtId ? this.data.aliasTgtId : this.data.id;

            this.$root.app.movingAdding = this.data.id
            az.addRemSpinner(true, 'id', 'transDrop'  + self.listIndex)
            this.$root.app.apiClient.get('subs/data/bundle/' + al + '/' + this.offset, {}, w, n)
           

        },
        refreshData: function(){
            this.$root.app.InitialDataLoad(true);
        },
        doOnScroll: function(){
            AZEventBus.$emit('closeAllMenus', null)
        },
        handleDragOver: function(data, event){
            if(data && data.type == 'list'){
                this.dragging = true;
                this.$parent.enableScrollHelpers()
            }
        },
        dragEnd: function(){
            this.dragging = false
            this.$parent.disableScrollHelpers()
        },
        doDrop: async function(data, event){

               /*  if(data.collabId && data.fromSub){
                    this.$root.app.showModalOK({message:'Moving bundles in and out of Collab bundles is restricted for now. Stay tuned.'})
                    this.dragging = false;
                    return
                } */
               

                if(data.collabId && data.fromSub){
                    if(await this.$root.app.checkDescendantsForForeign(data.draggedId)){
                        this.dragging = false
                        this.$root.app.showModalOK({message: 'This bundle has content contributed by other collab members. Please remove this content before moving the bundle out of the collab.'})
                        
                        return
                    }
                    /* this.$root.app.showModalOK({message: 'Removing bundles from collab bundle coming soon. Stay tuned'})
                    return */ 
                }
           
           
                let movedBundle = this.$root.app.bundles.findIndex((e) => {
                    return e.id == data.draggedId
                })

                var copyOfBundle,
                copyOfBundle = this.$root.app.bundles[movedBundle] 

                let openWindowId
                if(this.$parent.windowOpen){
                    openWindowId = this.$root.app.bundles[this.$parent.currOpenWindow].id
                    
                }

                //Move the bundle
                if(data.fromSub){
                    this.$root.app.bundleMover(data.bundleId, 'root', this.listIndex, copyOfBundle, this.$root.app, [data.bundleId], null, null, null, data.aliasTgtId, null)
                            /* parentId, targetId, targetIndex, bundle, app, branch, listIndex) */                         
                } else {
                    let rootId = copyOfBundle.branch[0]
                    copyOfBundle = this.$root.app.bundles.find(e => {
                        return e.id == rootId;
                    }) 
                   
                    let draggedListIndex = this.$root.app.treeNoInbox.findIndex(e => {
                        return e.id == rootId;
                    })

                    
                    this.$root.app.bundleMover('root', 'root', this.listIndex, copyOfBundle, this.$root.app, null, draggedListIndex, null, null, data.aliasTgtId, null)
                }

                //TODO fix this --reset open window 
                if(this.$parent.windowOpen){
                    let lInd = this.$root.app.treeNoInbox.findIndex(e => {
                        return e.id == openWindowId
                    })

                    this.$parent.openWindow(openWindowId, lInd, this.breadCrumbs[0].id)
                }

            this.dragging = false;
            this.$parent.disableScrollHelpers()
        },
        dragStart: function(data, e){
            if(this.conts.isRoot){
                this.$root.app.bundleDraggerText = this.conts.listName
            } else {
                this.$root.app.bundleDraggerText = this.breadCrumbs[0].listName
            }
           
            var imgt = this.$refs.me //document.getElementById('bundleDragger')
            e.dataTransfer.setDragImage(imgt, 0, 30);
            this.$parent.enableScrollHelpers()
        },

        //Load bundle from breadcrumbs:
        subBack: function(id, index, bypass){
            
            var self = this
            
            if((this.breadCrumbs.length < 2 || id == this.conts.id) && !bypass) return

            //this.breadCrumbs.splice(index + 1)
            
            this.data = this.$root.app.bundles.find(e => { 
                return id == e.id
            })

            if(this.data.offset){
                this.offset = this.data.offset
            } else {
                this.data.offset = 0
            }


            //this.offset = this.conts.items.length
           
            this.data.isPublic = this.$root.app.bundles.find(e => { 
                return self.rootId == e.id
            }).isPublic

            
            
            this.checkPlaceholders()
            

           
        },

        upLevel: function(){
            this.subBack(this.breadCrumbs[this.breadCrumbs.length -2 ].id, this.breadCrumbs.length - 2, true)
        },
        
        loadRoot: function(){
            var self = this
            this.data = this.$root.app.bundles.find(e => { 
                return self.rootId == e.id
            })
        },

        buildAdQuery: function(){

            var self = this;
            var subBundleNames = []
            var miimuTitles = []
            var miimuDescriptions = []

            this.data.children.forEach(e => {
                if(e)
                    subBundleNames.push(e.listName)
            })

            if(this.$refs.cardRef){
                this.$refs.cardRef.forEach(e => {
                    miimuTitles.push(e.item.title)
                    miimuDescriptions.push(e.item.description)
                })
            }

            function w(d){
                this.ad = d.ad
            }

            function n(){

            }



            //this.$root.app.apiClient.post('subs/data/getonead', {subs: subBundleName, titles: miimuTitles, descs: miimuDescriptions}, w, n)
        },

        makeCollab: function(){
            this.$root.app.showModalOK({message: 'This bundle will be converted to a Collab bundle. Note: this process cannot be undone.', callBack: this.doMakeCollab})
        },

        doMakeCollab: function(){
            this.$root.app.closeModal()

            var self = this;

            function w(d){
                if(d.collabId){
                    self.data.collabId = d.collabId
                    //
                    self.$root.app.bundles.forEach(e => {
                        if(e.rootId == self.data.id){
                            e.collabId = d.collabId
                        }
                    })

                    self.$root.app.treeNoInbox.forEach(e => {
                        if(e.rootId == self.data.id){
                            e.collabId = d.collabId
                        }
                    })

                }
            }

            function n(){

            }

            this.$root.app.apiClient.put('/subs/data/makecollab', {id: this.data.id}, w, n)
        },
        //

        //Load Sub Bundle:
        loadSub: function(b, ind){
            this.riseSubLabel(b, ind)
        },
        /* loadSubFromDropdown: function(b, ind, parent){
            this.riseSubLabel(b, ind)
        }, */
        riseSubLabel: function(b, ind){
            var self = this
            //console.log(b)
            //this.$refs.subLabel[ind].classList.add('subLabelRise')
            //setTimeout(() => {
           

           
            //this.$refs.subLabel[ind].classList.remove('subLabelRise')
          
            this.data = b

            this.checkPlaceholders()

            if((this.conts.itemsLoaded != true && this.conts.isRoot == false) || this.conts.forceLoadFromInject){
                //this.offset = this.conts.items.length
                this.offset = this.data.offset || 0
                this.loadItems()
            }

            this.data.isPublic = this.$root.app.bundles.find(e => { 
                return self.rootId == e.id
            }).isPublic


            //}, 200)
        },
        openEditContext: function(){
            this.$root.app.loadedModalComponent = ModalEditContext;
            let n = ''
            if(this.conts.pubNote)
                n = this.conts.pubNote.slice()
            this.$root.app.modalPropsObj = {callBack: this.updNotes, text: n } //this.$refs.bNotesPubl.innerText
            this.$root.app.showModal = true
        },

        openCollabMenu: function(e){
            e.stopPropagation() 
            if(!this.showGroup) 
                this.showGroup = true; 
            else 
                this.showGroup = false
        },
        //

        sortIt: function(){
          this.sortDirection  = !this.sortDirection;
          if(this.sortDirection)
            this.data.items.sort(function(a,b){ return a.p - b.p})
          else
            this.data.items.sort(function(a,b){ return b.p - a.p})
        },
        sort: function(){
            this.data.items.sort(function(a,b){ return a.p - b.p})
        },
        showMenu: function(){
           
            if(!this.showControlsMenu){
                event.stopPropagation();
                this.showControlsMenu = true
            }
        },
        shareIt: function(){
            this.sortTrayOpen = false
            this.$root.app.doShowModal('ModalShare', {id: this.conts.id, branch: this.conts.branch})
            this.showControlsMenu = false
        },
        makePublic: function(){
            if(!this.conts.isRoot){
                this.$root.app.showModalOK({message: 'You may not make a sub bundle public. Only root bundles can be public.'})
                return
            }
            if(this.conts.collabId && this.conts.isAlias){
                this.$root.app.showModalOK({message: 'Collab bundles can only be made public by the collab admin.'})
                return
            }
            this.$root.app.doShowModal('ModalMakePublic', {id: this.conts.aliasTgtId || this.conts.id, isPublic: this.conts.isPublic ? true : false})
            this.showControlsMenu = false
        },
        newSubBundle: function(){
            this.$root.app.loadedModalComponent = ModalNewSub;
            this.$root.app.modalPropsObj = {callBack: this.saveSub, collabId: this.conts.collabId, selectedId: this.conts.id, selectedAliasId: this.data.aliasTgtId}
            this.$root.app.showModal = true
        },
        saveSub: function(bundleName){
           var self = this;
           var thisBundle;

           function w(data){

                self.$root.app.movingAdding = false
                
                if(data == 'miimu limit exceeded'){
                        if(!self.$root.app.inApp)
                            self.$root.app.doShowModal('ModalUpg', {limit: 'b'})
                        else
                            self.$root.app.doShowModal('ModalOK', {message: `Congratulations! You've created a ton of bundles! To create more, please visit your account info page from any web browser.`})

                        return
                    }

                
                self.$root.app.closeModal()

                let bId = data.response
                let newBranch = self.conts.branch.concat([bId])
                let b = bFactory(bId, false, bundleName, newBranch)
                b.collabId = self.conts.collabId
                b.id_cog = self.$root.app.userAttrs.sub
                self.$root.app.bundles.push(b);
                thisBundle = self.$root.app.bundles.find((e) => {
                    return e.id == self.conts.id
                })
                thisBundle.children.unshift(b)
             }

            function n(){
                self.$root.app.movingAdding = false
                self.$root.app.closeModal()
                self.$root.app.showModalOK({message: 'There was an error processing your request, please try again or contact support.'})
            }

            var checkLimits = this.$root.app.checkLimits

            this.$root.app.movingAdding = this.conts.id
            self.$root.app.doShowModal('FullSpinner', {})
            self.$root.app.apiClient.post('subs/data/bundle', {checkLimits: checkLimits, name: bundleName, isRoot: false, targetBundle: self.conts.aliasTgtId || self.conts.id, p: null, collabId: this.conts.collabId}, w, n);
        },
        deleteBundle: function(){
            //this is handled in ModalNewSub Component
        },
        editBundle: function(){
            this.sortTrayOpen = false
            this.$root.app.loadedModalComponent = ModalNewSub;

            var selectedId
            var selectedAliasId

            if(this.conts.branch.length == 1){
              selectedId = 0;
              selectedAliasId = 0
            } else {
                selectedId = parseInt(this.conts.branch[this.conts.branch.length - 2])
                selectedAliasId = parseInt(this.conts.branch[this.conts.branch.length - 2])
            }

            this.$root.app.modalPropsObj = {callBack: this.doEdit, callBack2: this.addMembers,  bundleName: this.conts.listName, createOrEdit: 'edit', bundleId: this.conts.id, sub: !this.conts.isRoot, collabId: this.conts.collabId, bParent:  this.breadCrumbs.length > 1 ? parseInt(this.breadCrumbs[this.breadCrumbs.length - 2].id ): null, aliasTgtId: this.conts.aliasTgtId, selectedId: selectedId, selectedAliasId: selectedAliasId, me: this.conts.id, caller: this }
            this.$root.app.showModal = true
        },
        doEdit: function(bundleName, xxx, yyy, zzz, wrapperId, aliasTgtId, selectedCollabId, doChangeParent){
            var self = this

            window.scrollTo(0,0)
            
            function w(){
                let thisBundle = self.$root.app.bundles.find((e) => {
                    return e.id == self.conts.id;
                })
                thisBundle.listName = bundleName;

                setTimeout(moveIt, 100)
            }

            function n(){
                self.$root.app.showModalOK({message: 'There was an error processing your request, please try again or contact support.'})
            }
            self.$root.app.apiClient.put('subs/data/bundle', {listName: bundleName, targetId: self.conts.aliasTgtId || self.conts.id, collabId: self.conts.collabId, oldName: self.conts.listName}, w, n);

            
            let parentId = null
            let listIndex = null
            if(this.conts.branch.length == 1){
                parentId = 'root'
                listIndex = this.$root.app.treeNoInbox.findIndex(e => {
                    return e.id == parseInt(this.conts.branch[0])
                })
            } else {
                parentId = this.conts.branch[this.conts.branch.length - 2]
            }

            async function moveIt(){
                if(doChangeParent){
                    var copyOfBundle = self.$root.app.bundles.find((e) => {
                            return e.id == self.conts.id
                    })

                copyOfBundle = JSON.parse(JSON.stringify(copyOfBundle))

                if(selectedCollabId != self.conts.collabId && (selectedCollabId && self.conts.collabId)){
                        self.$root.app.closeModal()
                        setTimeout(function(){
                            self.$root.app.showModalOK({message: "You cannot put a collab bundle into another collab bundle."})
                        },20)
                    
                        return;
                    
                }

                if(selectedCollabId != self.conts.collabId && selectedCollabId){
                    self.$root.app.closeModal()

                    var par = self.$root.app.bundles.find(e => {
                        return e.id == parentId
                    })

                    var parIndex = self.$root.app.treeNoInbox.findIndex(e => {
                        return e.id == parIndex
                    })

                    setTimeout(function(){
                        self.$root.app.doShowModal('ModalDragbtoc', {message: 'You are moving a bundle into a collab bundle. Would you like to move it, or create a copy of it.', 
                        callBack: self.doDragBIntoCollab,
                        payload: {
                            index: 0, 
                            aliasTgtId: aliasTgtId, 
                            collabId: selectedCollabId,
                            targetId: aliasTgtId || wrapperId, 
                            data: {
                                draggedId: self.conts.id,
                                bundleId: parentId,
                                listIndex: parIndex
                            }, 
                            parentId: self.conts.aliasTgtId || self.conts.id, 
                            event: event, 
                            branch: par? par.branch : [],
                            //doLevelUp: true,
                            levelUp: self.upLevel
                        },
                        fromTreeMover: true
                        })
                    },20)
                    return
                } else if(selectedCollabId != self.conts.collabId && self.conts.collabId){
                    
                    if(self.conts.isRoot == true){
                        self.$root.app.closeModal()
                        setTimeout(function(){
                            self.$root.app.showModalOK({message: 'Putting collab bundles into other bundles is restricted for now. Stay tuned.'})
                            },20)
                        return
                    } else {
                        
                        if(await self.$root.app.checkDescendantsForForeign(self.rootId)){
                            self.$root.app.closeModal()
                            setTimeout(function(){
                                self.$root.app.showModalOK({message: 'This bundle has content contributed by other collab members. Please remove this content before moving the bundle out of the collab.'})
                            },20)
                            return
                        }
                        /* this.$root.app.showModalOK({message: 'Removing bundles from collab bundle coming soon. Stay tuned'})
                        return */
                    }

                }

                self.$root.app.bundleMover(parentId, aliasTgtId || wrapperId, 0, copyOfBundle, self.$root.app, self.conts.branch, listIndex, null, null, self.conts.aliasTgtId, selectedCollabId, self.upLevel)
                
                }
            }
        },
        toggleSortOpen: function(){
            this.sortTrayOpen = !this.sortTrayOpen
        },
        removeBundleFromCardsParents: function(){
            for(let i=0; i < this.conts.items.length; i++){
                let card = this.$root.app.cards[this.conts.items[i].cardsIndex]
                let ind = card.parents.findIndex(e => {
                    return e.id == this.conts.id
                })
                card.parents.splice(ind, 1)
            }
        },

        toggleMultiple: function(){

            if(this.data.items.length == 0) {
                this.$root.app.showModalOK({message: 'There are no miimus in this bundle.'})
                return
            }
            
            this.inMultiSelect = !this.inMultiSelect

            if(!this.inMultiSelect){
                this.sortTrayOpen = false
            }

            this.showControlsMenu = false
        },
       /*  subBundleDragEnter: function(index){
           //this.$refs.subBundle[index].$el.firstChild.firstChild.subBundleLabel.classList.add('has-background-coolGreen')
           //this.$refs.subBundle[index].$el.firstChild.firstChild.classList.add('bundleOnDragEnter')
        },

        subBundleDragLeave: function(index){
           //this.$refs.subBundle[index].$el.firstChild.firstChild.classList.remove('has-background-coolGreen')
           //this.$refs.subBundle[index].$el.firstChild.firstChild.classList.remove('bundleOnDragEnter')
        }, */

        crumbDragEnter: function(index, data){
            if(1==1){ //data.type == 'card'
                 this.$refs.crumb[index].classList.add('botBorder')
            }
           //this.$refs.subBundle[index].$el.firstChild.firstChild.classList.add('bundleOnDragEnter')
        },

        crumbDragLeave: function(index){
            
            this.$refs.crumb[index].classList.remove('botBorder')
        
           //this.$refs.subBundle[index].$el.firstChild.firstChild.classList.remove('bundleOnDragEnter')
        },

        openHistory: function(){
            this.$root.app.openHistory(this.breadCrumbs[0].id, this.conts.collabId, this.breadCrumbs[0].listName, this.listIndex, this.conts.lastActivityId, this)
        },

        asyncLoadItems: function(){
            if(this.data.items.length != true && this.data.isRoot == false){
                this.loadItems()
            }
        },
        

        subBundleDrop: async function(id, index, aliasTgtId, data, event){

            this.$refs.crumb[index].classList.remove('botBorder')
            //this.loaded = false

            if(data.type == 'card'){

                    let fromBundleId = data.bundleId
                    let cardId = data.cardId
                    let cardsIndex = data.cardsIndex
                    let toBundleId = this.aliasTgtId || id
                    let before = -1;
                    let after = -1;

                   /*  let bInd = this.$root.app.bundles.findIndex(e => {
                        return e.id == id
                    })

                    if(this.$root.app.bundles[bInd].items.length)
                        after = this.$root.app.bundles[bInd].items[0].entryId;
                    else
                        after = false */

                      if((this.$root.app.cards[data.cardsIndex].id_cog != this.$root.app.userAttrs.sub) && (data.parentCollabId != this.conts.parentCollabId)){
                        this.$root.app.showModalOK({message: 'This card was not contributed to this collaboration by you. You cannot move it outside this collab bundle. Make a copy instead?', 
                                                    callBack: this.$root.app.copyCardCallback, 
                                                    payload: {url: '', cardsIndex: data.cardsIndex, callApi: false, collabId: this.conts.collabId, caller: this, bundleId: id, before: before, after: after, fromBundleId: data.trueFromBundleId}})
                            this.dragging = false
                            return
                        } 

                    let self = this

                    function callBack(rePosition, newPos){
                        //self.$parent.sort()
                        //self.dragging = false
                        

                    }

                    this.$root.app.cardMover(fromBundleId, cardId, toBundleId, before, after, this.$root.app, callBack, cardsIndex, aliasTgtId)

                } else if(data.type == 'list'){

                    let tgtBundle = this.$root.app.bundles.find(e => {
                
                        return e.id == id
                    })
                    let tgtCollabId = tgtBundle.collabId
                    
                    
                    if(data.draggedId == tgtBundle.id) {
                        return
                    }

                    if(data.collabId != this.conts.collabId && (data.collabId && this.conts.collabId)){
                        this.$root.app.showModalOK({message: "You cannot put a collab bundle into another collab bundle."})
                        return;
                    }

                    if(data.collabId != tgtCollabId && tgtCollabId){
                        this.$root.app.doShowModal('ModalDragbtoc', {message: 'You are moving a bundle into a collab bundle. Would you like to move it, or create a copy of it.', callBack: this.doDragBIntoCollab, payload: {id:id, index: 0, aliasTgtId: aliasTgtId, collabId:this.conts.collabId, targetId: this.conts.aliasTgtId || this.conts.id, data: data, event: event, branch: this.conts.branch}})
                        return
                    } else if(data.collabId != tgtCollabId && !tgtCollabId){
                        if(data.fromSub == false){
                            this.$root.app.showModalOK({message: 'Putting collab bundles into other bundles is restricted for now. Stay tuned.'})
                            return
                        } else {
                            if(await this.$root.app.checkDescendantsForForeign(data.draggedId)){
                                this.$root.app.showModalOK({message: 'This bundle has content contributed by other collab members. Please remove this content before moving the bundle out of the collab.'})
                                return
                            }
                            /* this.$root.app.showModalOK({message: 'Removing bundles from collab bundle coming soon. Stay tuned'})
                            return */
                        }
                    }

                    if(!this.conts.isRoot){
                        
                        let parentCheck = this.breadCrumbs.findIndex(e => {
                            return e.id == data.draggedId
                        })

                        if(parentCheck > -1){
                            this.$root.app.showModalOK({message:'You may not move a bundle into one of its children.'})
                            return
                        }
                    }

            
                    
                    let movedBundle = this.$root.app.bundles.findIndex((e) => {
                        return e.id == data.draggedId
                    })

                    var copyOfBundle,
                    copyOfBundle = this.$root.app.bundles[movedBundle] //JSON.parse(JSON.stringify(this.$root.app.bundles[movedBundle]))
            
                    if(!this.info.isRoot){
                        if(this.subBundle.branch[0] == copyOfBundle.id){
                            this.$root.app.showModalOK({message: "A bundle cannot be a child of itself"})
                            return
                        }
                    }

                    if(data.fromSub){
                        this.$root.app.bundleMover(data.bundleId, tgtBundle.id, 0, copyOfBundle, this.$root.app, tgtBundle.branch, null, null, this.bundleId, tgtBundle.aliasTgtId, this.conts.collabId );

                    } else { 
                        let rootId = copyOfBundle.branch[0]
                        copyOfBundle = this.$root.app.bundles.find(e => {
                            return e.id == rootId;
                        }) 
            
                        let draggedListIndex = this.$root.app.treeNoInbox.findIndex(e => {
                            return e.id == rootId;
                        })

                        this.$root.app.bundleMover('root', tgtBundle.id, 0, copyOfBundle, this.$root.app, tgtBundle.branch, draggedListIndex, null, null, tgtBundle.aliasTgtId, this.conts.collabId );
                    }

                }

                this.dragging = false;
                this.$parent.disableScrollHelpers()
        }, 

        localSearch: function(s){
          var p = {
            id: this.aliasTgtid || this.conts.id,
            collabId: this.conts.collabId,
            listName: this.conts.listName,
            localBundle: this,
            terms: this.terms,
            rootId: this.conts.rootId
          }
          this.$parent.$refs.searchComp.localPayload = p
          this.$parent.$refs.searchComp.isLocal = true
          this.$parent.$refs.searchComp.inputOpen = true
          this.$parent.$refs.searchComp.doLocalSearch()
          this.terms = ''
        },


        doDragBIntoCollab: function(payload){
            
            var self = this;

            function w(d){
               self.$root.app.InitialDataLoad(true)
              
            }

            function n(){
            }

            /*  if(payload.doLevelUp){
                   self.upLevel()
               } */


            this.$root.app.apiClient.put('subs/data/copybintocollab', {id: payload.data.draggedId, collabId: payload.collabId, index: payload.index, targetId: payload.targetId, parentId: payload.data.bundleId || 'root'}, w, n)
            this.$root.app.closeModal()
        },
        openBundleTree: function(event){
            if(this.info.children.length){
                event.stopPropagation();
                this.showBundleTree = true
            }
        },
        stopProp: function(event){
            event.stopPropagation();
        },

        openMulti: function(){
            
            var self = this

            if(this.multiSelections.length == 0){
                this.$root.app.showModalOK({message: 'You must select at least one miimu'})
                return
            }
            
            var ids = []
            this.multiSelections.forEach(e => {
                ids.push(e.id)
            })

            ids.forEach((e, i) => {
                var found = false
                for(var x=0; x < self.conts.items.length; x++){
                    if(self.conts.items[x].id == e){
                        found = true
                        break
                    }
                }

                if(!found){
                    self.multiSelections.splice(i, 1)
                }
            })

        


            this.$root.app.doShowModal('ModalMulti', {message: '', items: this.multiSelections, callBack: this.closeMulti, selectedId: this.conts.id, selectedAliasId: this.conts.aliasTgtId, collabId: this.conts.collabId })
        },

        closeMulti: function(){
            var self = this;
            this.$refs.cardRef.forEach(b => {
                b.isSelected = false
            })

            self.inMultiSelect = false
            self.multiSelections.splice(0)
            self.sortTrayOpen = false

        },

        flashBundle: function(){
            var self = this;
            this.$refs.listContainer.classList.add('bundleFlasher')
            setTimeout(function(){
                self.$refs.listContainer.classList.remove('bundleFlasher')
            }, 500)
        },

        doImportedInfo: function(event){
            event.stopPropagation();
            this.showImportedInfo = true

            var self = this

            function w(d){
                az.addRemSpinner(false, 'class', 'holder')
                self.sharedBy = d.sharedBy
                self.sharedOn = d.sharedOn
                self.sbId = d.sbId
            }
            function n(){
                az.addRemSpinner(false, 'class', 'holder')
            }

            az.addRemSpinner(true, 'class', 'holder')
            this.$root.app.apiClient.get('subs/data/importeddata/' + this.conts.shareId, {}, w, n)
        },

        doOfferUpdatePush(){
            var self = this

            if(this.hasDirtyChildren){
                var b = this.$root.app.treeNoInbox.find(e => {
                    return e.id == this.breadCrumbs[0].id
                })
                self.$router.push({name: 'sb', params: {theBundle: [b], isPush: true}})
            } else {
                this.$root.app.showModalOK({message: 'There are no additions to any shared bundles that require updating.'})
            }
           
            
        },

        navToSB: function(){
            this.$router.push('/sb' + '?s=' + this.sbId)
        },
        openNotes: function(){
            this.sortTrayOpen = false
            if(!this.notesOpen){
                this.notesOpen = true
            } else {
                this.notesOpen = false
            }
            this.showControlsMenu = false
           
        },
        expandBundle: function() {
            this.openThisB = true
        },
        collapseBundle: function() {
            this.openThisB = false
        },
        doBundleState: function(){
            this.openThisB = !this.openThisB
        },

        toggleFulled: function(){
            this.sortTrayOpen = false
            if(this.$root.app.fulled){
                this.$root.app.fulled = false
                this.$root.app.fulledBundle =  null
            } else {
                this.$root.app.fulled = true
                this.$root.app.fulledBundle = this.conts.branch[0]
                document.getElementById('listsHolder').scrollTo(0,0)
            }

            this.resizeForInbox()


            this.showControlsMenu = false
        },
        updNotes: function(pubNew){

            let self = this;
            let changes = {}

            let privNew = this.$refs.bNotesPriv.innerText
           /*  let pubNew = this.$refs.bNotesPubl.innerText */

            //if(pubNew == '' || pubNew == undefined) this.pbPlaceholder = true
            if(privNew == '') this.pvPlaceholder = true

            if(this.conts.privNote != privNew)
                changes.privNote = privNew

            if(this.conts.pubNote != pubNew && pubNew != 'nothing')
                changes.pubNote = pubNew

            if(changes.hasOwnProperty('privNote') || changes.hasOwnProperty('pubNote')){
                
                function w(){
                    self.$root.app.movingAdding = false
                    let thisBundle = self.$root.app.bundles.find((e) => {
                        return e.id == self.conts.id;
                    })
      
                    thisBundle.privNote = privNew
                    thisBundle.pubNote = pubNew
                }

                function n(){
                    self.$root.app.movingAdding = false
                    self.$root.app.showModalOK({message: 'There was an error processing your request. Please try again or contact support.'})
                }

                this.$root.app.movingAdding = this.conts.id
                this.$root.app.apiClient.put('subs/data/updbundlenotes', {changes: changes, bundleId: this.conts.id, collabId: this.conts.collabId, aliasTgtId: this.conts.aliasTgtId || this.conts.id}, w, n);
                
            }
        },

        pbPlaceholderFocus: function(){
           //this.pbPlaceholder = false
        },

        pvPlaceholderFocus: function(){
           this.pvPlaceholder = false
        },

        checkPlaceholders: function(){
           /*  if(this.conts.pubNote == '') this.pbPlaceholder = true 
            else this.pbPlaceholder = false */
            
            if(this.conts.privNote == '') this.pvPlaceholder = true 
            else this.pvPlaceholder = false
        },

        addToMulti: function(obj){
            for(var x=0; x < this.multiSelections.length; x++){
                if(this.multiSelections[x].id == obj.id){
                    return
                }
            }

            this.multiSelections.push(obj)
            
        },

        removeFromMulti: function(obj){
            this.multiSelections = this.multiSelections.filter(e => {
                return e.id != obj.id
            })
        },
        /*collabMine: function(){
            
             var rootIdCog
            if(this.info.isRoot && !this.info.isAlias){
                return this.info.id_cog == this.$root.app.userAttrs.sub
            } else if(this.info.isRoot && this.info.isAlias) {
               for(var x=0; x<this.$root.app.bundles.length; x++){
                   if(this.$root.app.bundles[x].id == this.data.aliasTgtId){
                       rootIdCog = this.$root.app.bundles[x].id_cog
                       break;
                   }
               }
               
                return rootIdCog == this.$root.app.userAttrs.sub
            } else {
                
                for(var x=0; x<this.$root.app.bundles.length; x++){
                   if(this.$root.app.bundles[x].aliasTgtId == this.data.branch[0].id){
                       rootIdCog = this.$root.app.bundles[x].id_cog
                       break;
                   }
               }

                return rootIdCog == this.$root.app.userAttrs.sub;
            } 
        },*/
        addMembers: function(ownerLeaving){
            let memberArr = [];
            this.$root.app.groupMembers.forEach(e => {
                if(e.id_acl == this.data.collabId && e.id_customer != this.$root.app.userAttrs.sub){
                    memberArr.push(e.id_customer)
                }
            })

            // TODO FIND ID OF COLLABROOT BUNDLE TAKING ALIAS INTO ACCOUNT AND SEND IN BELOW REQUEST
            var rootCollabId
            if(this.info.isRoot && !this.info.isAlias){
                rootCollabId = this.info.id
            } else if(this.info.isRoot && this.info.isAlias) {
                rootCollabId = this.info.aliasTgtId
            } else {
                for(var x=0; x < this.$root.app.bundles.length; x++){
                   if(this.$root.app.bundles[x].aliasTgtId == this.data.branch[0].id){
                       rootCollabId = this.$root.app.bundles[x].id
                       break;
                   } 
               }

            }
          
            this.$root.app.doShowModal('ModalAddCollabMembers', {caller: this, ownerLeaving: ownerLeaving, members: memberArr, groupId: this.data.collabId, rootCollabId: rootCollabId, callBack: this.afterMembersAdded, callBack2: this.afterTransfer, groupMembers: this.groupMembers, bundleId: this.data.rootId})
        },
        afterMembersAdded: function(){
            
            this.$root.app.closeModal()
        },

        afterTransfer: function(id, ownerLeaving){ 

           
     

            var self = this;

            function w(){
                window.location.reload()
            }

            function n(){

            }
            
            if(ownerLeaving){
                var theKids = []
                function rec(kids){
                    kids.forEach(e => {
                        theKids.push(e.id)

                        if(e.children.length){
                            rec(e.children)
                        }
                    })
                }

                var bun = self.$root.app.bundles.find(i => {
                    return i.id == id
                })

                

                //recurse to get a list of all descendant ids
                rec([bun])

              /*   let bCheck = self.$root.app.bundles.find(e => {
                    return e.id == this.bParent
                })

                if(bCheck){
                    if(bCheck.aliasTgtId){
                        this.bParent = bCheck.aliasTgtId
                    }
                } */

                self.$root.app.apiClient.delete('subs/data/bundle', {bundleId: id, idList: `${id}`, collabId: this.collabId, parentId: this.bParent || null, aliasTgtId: this.aliasTgtId}, w, n);
            } else {
                window.location.reload()
            }

          
        },

        resizeForInbox: function(){
         let i = document.getElementById('leftBar')
         let h  = document.getElementById('inboxOpenerContainer')
         let b = document.getElementById('board')
         let l = document.getElementById('listsHolder')
         let s = document.getElementById('search')
         let bh = document.getElementById('boardHeader')
         let pb = document.getElementById('prefsButt')

         

         if(this.inbox){
          
         

           i.classList.remove('inboxHidden')
           h.classList.add('inboxOpenerHidden')
           b.classList.add('boardInboxOpen')
           l.classList.add('listsHolderInboxOpen')
           s.classList.add('searchInboxOpen')
           bh.classList.add('boardInboxOpen')
           pb.classList.add('prefsButtInboxOpen')

           
         } else {
           i.classList.add('inboxHidden')
           h.classList.remove('inboxOpenerHidden')
           b.classList.remove('boardInboxOpen')
           l.classList.remove('listsHolderInboxOpen')
           s.classList.remove('searchInboxOpen')
           bh.classList.remove('boardInboxOpen')
           pb.classList.remove('prefsButtInboxOpen')
         
 
          
         }
      },

      checkOverflow: function(){

        if(this.$refs.breadCrumbsDiv){
            var self = this;
            setTimeout(function(){
                var scroll =  self.$refs.breadCrumbsDiv ? self.$refs.breadCrumbsDiv.scrollWidth : 0
                var el = self.$refs.breadCrumbsDiv ? self.$refs.breadCrumbsDiv.offsetWidth : 0
                self.crumbsOverflow = scroll > el
                self.$refs.breadCrumbsDiv.scrollLeft = self.$refs.breadCrumbsDiv.scrollWidth;
            },1)
        }


        
      },

      rMousePress: function(){
        this.scrollRight()
      },

      lMousePress: function(){
        this.scrollLeft()
      },

      mouseRelease: function(){
        this.down = false;
        window.clearInterval(this.ii)
        window.clearInterval(this.ii2)
      },

      scrollRight: function(){
        var self = this            
        self.ii = setInterval(function() { self.$refs.items.scrollBy(5, 0) }, 7 )
   
      },

    

      scrollLeft: function(){
        var self = this
        self.ii2 = setInterval(function(){self.$refs.items.scrollBy(-5, 0)}, 7 )

      },

      startSelectFromSearch(arr){
        this.loadItems(this.selectFromSearch(arr))
      },

      selectFromSearch: function(arr){

        var self = this
        this.inMultiSelect = true
        this.showControlsMenu = false

        this.multiSelections.splice(0);
        this.$refs.cardRef.forEach(e => {
            if(e.itemIndex != undefined){
                if(arr.includes(e.id)){
                    e.isSelected = true
                    self.multiSelections.push(e.item)
                } else {
                    e.isSelected = false
                }
            }
        })

      },

      selectAll: function(){
        
        var arr = []
        this.conts.items.forEach(e => {
            arr.push(e.id)
        })

        this.selectFromSearch(arr)
      },

      unSelectAll: function(){
        this.multiSelections.splice(0);
        this.$refs.cardRef.forEach(e => {
            if(e.itemIndex != undefined){
                e.isSelected = false
            }
        })
       
      },

      filterTypeChanged: function(id, name) {
        if(id == 'no filter'){
            this.filterByType = false
        }
        this.filterByType = id

        this.filterTypeDrop = false
        this.showControlsMenu = false
        
      },

    },  
    computed: {

        scrollerVisible: function(){
            return this.$el.scrollWidth > this.$el.clientWidth;
        },

        
        currFilterTypeName: function(){
            let f = this.$root.app.typeFilters.find(e => {
                return e.id == this.filterByType
            })

            if(f){
                return f.name
            }

            return 'No Filter'

        },
      

        conts: function(){

            var self = this

            if(!this.data.id)
                return {items: [], branch: [-1]}


           

           
            
            //this.data.items.sort(function(a,b){ return a.p - b.p})
            
           
            this.rootName = this.info.listName;
            this.breadCrumbs = []
            if(!this.isRoot){
                if(this.data.branch){
                    if(this.data.branch.length){
                        for(var i = 0; i < this.data.branch.length; i++){
                            var b;
                            for(var x=0; x < this.$root.app.bundles.length; x++){
                                if(this.$root.app.bundles[x].id  == this.data.branch[i]){
                                    b = this.$root.app.bundles[x];
                                    break;
                                }
                            }

                            if(i==0) 
                                this.rootId = b.id
                            this.breadCrumbs.push({listName: b.listName, id: b.id, aliasTgtId: b.aliasTgtId})
                           
                        }
                    }
                }
            } else {
                this.rootId = this.conts.id
            }
            this.showPrivate = false

            ////

             var rootIdCog
            if(this.info.isRoot && !this.info.isAlias){
                //this.collabMine = !this.isAlias
            } else if(this.info.isRoot && this.info.isAlias) {
               for(var x=0; x<this.$root.app.bundles.length; x++){
                   if(this.$root.app.bundles[x].id == this.data.aliasTgtId){
                       rootIdCog = this.$root.app.bundles[x].id_cog
                       break;
                   }
               }
               //this.collabMine = !this.info.isAlias
              
                this.collabId = rootIdCog == this.$root.app.userAttrs.sub;
            } else {
                
                for(var x=0; x<this.$root.app.bundles.length; x++){
                   if(this.$root.app.bundles[x].aliasTgtId == this.info[0]){ //.id
                       rootIdCog = this.$root.app.bundles[x].id_cog
                       break;
                   }
               }

                //this.collabMine = !this.info.isAlias
                
            }

            var theId

            if(this.data.isRoot){
                theId = this.data.aliasTgtId || this.data.id
            } else {
                theId = this.data.rootId || this.data.id   //may not need this.data.id, may cause problems?
            }

            var rBid_cog = this.$root.app.bundles.find(e => {
                return e.id == theId
            }).id_cog
        
            this.collabMine = rBid_cog == this.$root.app.userAttrs.sub ? this.collabMine = true : this.collabMine = false

            ////
            if(!this.info.isRoot){
                this.rootIsCurrent = false
            } else {
                this.rootIsCurrent = true
            }

            var self = this
            setTimeout(function(){
                self.buildAdQuery()
            }, 100)
            
            
            return this.data || {items: [], branch: [-1]}
        },
        dummy: function(){
          
        },

        groupMembers: function(){
         
            var esto = this

            const uniqueArray = this.$root.app.groupMembers.filter((value, index, self) =>
                index === self.findIndex((t) => (
                    t.id_acl === value.id_acl && t.id_customer === value.id_customer && t.active === value.active
                ))
            );
            

            return uniqueArray.filter(e => { 
                return e.id_acl == esto.data.collabId && e.active != '33'
            })
        },

        
        
    },
    watch:{
        info: function(){

            this.data = this.info;

           
           
           
        },

        conts: function(){
            //var self = this;
            this.checkOverflow()

          

           
        }
        
    }
}
</script>